export const createInitialFormData = (automation, notification) => {
    return {
        ...automation,
        notification: {
            ...notification,
        },
    };
};
